import Exports from "../../Pages/Mega/Exports";
import {
  ADD_EVENT_FAIL,
  ADD_EVENT_SUCCESS,
  GET_EVENTS_FAIL,
} from "../calendar/actionTypes";
import {
  ADD_IDS_SUCCESS,
  DELETE_IDS_SUCCESS,
  GET_IDS_FAIL,
  GET_IDS_SUCCESS,
  UPDATE_IDS_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  ids: [],
  exports: [],
  defective: [],
  total: 0,
  pagination: { page: 1, per_page: 10, search: "" },
  error: {},
};

const IDS = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_IDS_SUCCESS:
      return {
        ...state,
        ...(action.payload.apples !== undefined && { ids: action.payload.apples }),
        ...(action.payload.exports !== undefined && {
          exports: action.payload.exports,
        }),
        ...(action.payload.defective !== undefined && {
          defective: action.payload.defective,
        }),
        total: action.payload.total ?? state.total,
        pagination: {
          page: action.payload.page ?? state.pagination.page,
          per_page: action.payload.per_page ?? state.pagination.per_page,
          search: action.payload.search ?? state.pagination.search,
        },
      };

    case GET_IDS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_IDS_SUCCESS:
      return {
        ...state,
        ids: [...(Array.isArray(state.ids) ? state.ids : []), action.payload],
      };

    case ADD_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_IDS_SUCCESS:
      return {
        ...state,
        ids: (Array.isArray(state.ids) ? state.ids : []).map((id) =>
          id.id === action.payload.id ? { id, ...action.payload } : id
        ),
        isEventUpdated: true,
      };

    // case UPDATE_EVENT_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //     isEventUpdated: false,
    //   };

    case DELETE_IDS_SUCCESS:
      return {
        ...state,
        ids: (Array.isArray(state.ids) ? state.ids : []).filter(
          (id) => id.id !== action.payload
        ),
      };

    // case DELETE_EVENT_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   };

    default:
      return state;
  }
};

export default IDS;
